import { Component } from 'react';
import DetailAttribute from './detailattribute';
import { Provider } from 'react-redux';
import store from '../../UI_ReactNative/FixErrorComponent/Redux';

class AppDetailAttribute extends Component {
  render() {
    return (
      <Provider store={store}>
        <DetailAttribute {...this.props} />
      </Provider>
    );
  }
}

export default AppDetailAttribute;
